import { useState } from "react";
import jsPDF from "jspdf";
import RoomVisualizer from "./RoomVisualizer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ===== Field Tools Tab (existing functionality) =====
const SCOPE_OPTIONS = [
  { key: "paint_walls", label: "Paint — Walls (2 coats)", cat: "Make-Ready" },
  { key: "paint_trim", label: "Paint — Trim & Doors", cat: "Make-Ready" },
  { key: "flooring_lvp", label: "Flooring — LVP", cat: "Make-Ready" },
  { key: "fixtures_kitchen", label: "Kitchen Faucet", cat: "Make-Ready" },
  { key: "fixtures_bath", label: "Bathroom Faucet(s)", cat: "Make-Ready" },
  { key: "fixtures_lighting", label: "Light Fixtures", cat: "Make-Ready" },
  { key: "hardware_cabinets", label: "Cabinet Hardware", cat: "Make-Ready" },
  { key: "hardware_doors", label: "Door Handles", cat: "Make-Ready" },
  { key: "plumbing_shower", label: "Shower Head(s)", cat: "Make-Ready" },
  { key: "countertops", label: "Countertop Refresh", cat: "Make-Ready" },
  { key: "drywall_patch", label: "Drywall Patch Kit", cat: "Make-Ready" },
  { key: "deep_clean", label: "Deep Clean (full unit)", cat: "Cleaning" },
  { key: "clean_blinds", label: "Blinds — dust/wipe", cat: "Cleaning" },
  { key: "clean_ceiling_fans", label: "Ceiling Fans", cat: "Cleaning" },
  { key: "clean_light_fixtures", label: "Light Fixtures — clean", cat: "Cleaning" },
  { key: "clean_baseboards", label: "Baseboards — scrub", cat: "Cleaning" },
  { key: "clean_windows_tracks", label: "Window Tracks & Sills", cat: "Cleaning" },
  { key: "clean_windows_glass", label: "Window Glass (interior)", cat: "Cleaning" },
  { key: "clean_cabinets_inside", label: "Cabinet Interiors", cat: "Cleaning" },
  { key: "clean_oven", label: "Oven & Range Hood", cat: "Cleaning" },
  { key: "clean_fridge", label: "Refrigerator & Freezer", cat: "Cleaning" },
  { key: "clean_dishwasher", label: "Dishwasher", cat: "Cleaning" },
  { key: "clean_microwave", label: "Microwave", cat: "Cleaning" },
  { key: "clean_counters_degrease", label: "Counters degrease", cat: "Cleaning" },
  { key: "clean_tile_grout", label: "Tile & Grout scrub", cat: "Cleaning" },
  { key: "clean_tub_shower", label: "Tub/Shower deep scrub", cat: "Cleaning" },
  { key: "clean_toilet", label: "Toilet sanitize", cat: "Cleaning" },
  { key: "clean_mirrors", label: "Mirrors/glass", cat: "Cleaning" },
  { key: "clean_doors_frames", label: "Doors & frames wipe", cat: "Cleaning" },
  { key: "clean_closets", label: "Closet shelves/rods", cat: "Cleaning" },
  { key: "clean_hvac_vents", label: "HVAC Vents/Returns", cat: "Cleaning" },
  { key: "clean_outlets_switches", label: "Outlet/switch plates", cat: "Cleaning" },
  { key: "clean_walls_spot", label: "Walls — spot clean", cat: "Cleaning" },
  { key: "clean_floors_detail", label: "Floors — mop/detail", cat: "Cleaning" },
  { key: "trash_full_removal", label: "Full Trash-Out", cat: "Trash-Out" },
  { key: "trash_furniture", label: "Furniture Removal", cat: "Trash-Out" },
  { key: "trash_carpet", label: "Carpet Removal", cat: "Trash-Out" },
  { key: "trash_bulk_haul", label: "Bulk Debris Hauling", cat: "Trash-Out" },
  { key: "trash_broom_clean", label: "Broom-Clean After", cat: "Trash-Out" },
  { key: "addon_carpet_shampoo", label: "Carpet Shampoo", cat: "Add-Ons" },
  { key: "addon_pressure_wash", label: "Pressure Wash Patio", cat: "Add-Ons" },
  { key: "addon_pest_prep", label: "Pest Treatment Prep", cat: "Add-Ons" },
  { key: "addon_odor_treatment", label: "Odor Treatment", cat: "Add-Ons" },
  { key: "feature_3d_pvc", label: "3D PVC Accent Wall", cat: "Feature Walls" },
  { key: "feature_fluted", label: "Fluted/Slat Panel Wall", cat: "Feature Walls" },
  { key: "feature_concrete", label: "Concrete-Look Accent", cat: "Feature Walls" },
  { key: "feature_marble_pvc", label: "Marble PVC Backsplash", cat: "Feature Walls" },
];

const PALETTE_OPTIONS = [
  { key: "modern_neutral", label: "Modern Neutral (Agreeable Gray + Matte Black)" },
  { key: "warm_contemporary", label: "Warm Contemporary (Accessible Beige + Brushed Nickel)" },
  { key: "cool_modern", label: "Cool Modern (Repose Gray + Matte Black)" },
  { key: "bright_clean", label: "Bright & Clean (Creamy + Brushed Brass)" },
];

const WalkThroughCalc = () => {
  const [form, setForm] = useState({ unit_type: "2br_1ba", sqft: 900, scope: ["paint_walls", "paint_trim", "flooring_lvp", "fixtures_lighting", "hardware_cabinets", "hardware_doors"], palette: "modern_neutral", notes: "", monthly_rent: 1500 });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shopifyOrder, setShopifyOrder] = useState(null);
  const [orderCopied, setOrderCopied] = useState(false);
  const [amazonCart, setAmazonCart] = useState(null);
  const [amazonCopied, setAmazonCopied] = useState(false);

  const toggleScope = (key) => {
    setForm(f => ({ ...f, scope: f.scope.includes(key) ? f.scope.filter(s => s !== key) : [...f.scope, key] }));
  };

  const calculate = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BACKEND_URL}/api/admin/walkthrough-calc`, {
        method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include",
        body: JSON.stringify(form)
      });
      if (r.ok) setResult(await r.json());
    } finally { setLoading(false); }
  };

  const downloadMaterialsPDF = () => {
    if (!result) return;
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("MOOVIN FORWARD INC. — MATERIAL ESTIMATE", 20, 20);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${new Date().toLocaleDateString()} | ${result.unit_type} | ${result.sqft} sq ft`, 20, 28);
    doc.text(`Palette: ${result.palette?.name || ""}`, 20, 33);
    doc.setDrawColor(0, 200, 200); doc.line(20, 36, 120, 36);

    let y = 44;
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("Item", 20, y); doc.text("Qty", 120, y); doc.text("Cost", 155, y);
    y += 6;
    doc.setFont("helvetica", "normal");
    result.materials.forEach(m => {
      if (y > 270) { doc.addPage(); y = 20; }
      const label = m.color ? `${m.item} — ${m.color}` : m.finish ? `${m.item} — ${m.finish}` : m.item;
      const lines = doc.splitTextToSize(label, 95);
      lines.forEach((line, i) => { doc.text(line, 20, y + (i * 4)); });
      doc.text(`${m.qty} ${m.unit}`, 120, y);
      doc.text(`$${m.cost.toFixed(2)}`, 155, y);
      y += Math.max(6, lines.length * 4 + 2);
    });
    y += 4;
    doc.setFont("helvetica", "bold");
    doc.text(`MATERIALS SUBTOTAL: $${result.subtotal.toFixed(2)}`, 120, y);
    y += 6;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(80);
    doc.text(`Historic budget cap for this unit type: $${result.materials_cap}`, 120, y);
    y += 4;
    if (result.over_cap) {
      doc.setTextColor(200, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.text(`Note: Subtotal exceeds the historic cap by $${(result.subtotal - result.materials_cap).toFixed(2)}.`, 120, y);
      y += 4;
      doc.setFont("helvetica", "normal");
      doc.setTextColor(80);
      const explainLines = doc.splitTextToSize(
        "This is normal when premium materials, vaulted ceilings, or larger sqft are involved. We flag it so the owner can approve the spec before procurement. Nothing is purchased above-cap without written sign-off.",
        78
      );
      explainLines.forEach((ln) => { doc.text(ln, 120, y); y += 3.5; });
      doc.setTextColor(0);
    } else {
      doc.setTextColor(0, 130, 80);
      doc.text("Status: Within historic budget cap. No owner approval required.", 120, y);
      doc.setTextColor(0);
      y += 4;
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    doc.setFontSize(7); doc.setTextColor(140);
    doc.text("CONFIDENTIAL — Moovin Forward | Pro account pricing. Do not distribute.", 20, 285);
    doc.save(`MF-Materials-${result.unit_type.replace(/_/g, "")}-${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  // Map walkthrough materials to Shopify products with retail pricing
  const MATERIAL_TO_SHOPIFY = {
    "ProMar 200 Eggshell": { sku: "MF-PNT-001", retail: 42, name: "Sherwin Williams ProMar 200 — Eggshell (Walls)" },
    "ProMar 200 Semi-Gloss": { sku: "MF-PNT-002", retail: 45, name: "Sherwin Williams ProMar 200 — Semi-Gloss (Trim/Doors)" },
    "PrimeRx Primer": { sku: "MF-PNT-003", retail: 34, name: "Sherwin Williams PrimeRx Primer" },
    "LVP": { sku: "MF-FLR-001", retail: 2.49, name: "Luxury Vinyl Plank — Standard (6mm, Click-Lock)" },
    "LVP Transition": { sku: "MF-FLR-003", retail: 8, name: "LVP Transition Strips (T-Molding)" },
    "Kitchen Faucet": { sku: "MF-FIX-001", retail: 75, name: "Kitchen Faucet — Single Handle, Pull-Down Sprayer" },
    "Cabinet Pulls": { sku: "MF-FIX-002", retail: 3.50, name: "Cabinet Hardware — Pulls (5\" Bar)" },
    "Cabinet Knobs": { sku: "MF-FIX-003", retail: 2.50, name: "Cabinet Hardware — Knobs (Round)" },
    "Bathroom Faucet": { sku: "MF-FIX-010", retail: 58, name: "Bathroom Faucet — 4\" Centerset" },
    "Showerhead": { sku: "MF-FIX-011", retail: 32, name: "Showerhead — Rain Style, 8\"" },
    "Towel Bar": { sku: "MF-FIX-012", retail: 22, name: "Towel Bar — 24\"" },
    "Toilet Paper Holder": { sku: "MF-FIX-013", retail: 15, name: "Toilet Paper Holder" },
    "Toilet Seat": { sku: "MF-FIX-014", retail: 28, name: "Toilet Seat — Elongated, Slow-Close" },
    "LED Flush Mount": { sku: "MF-LIT-001", retail: 26, name: "LED Ceiling Light — 12\" Flush Mount" },
    "Vanity Light": { sku: "MF-LIT-002", retail: 48, name: "Vanity Light — 3-Light Bar" },
    "LED Bulbs": { sku: "MF-LIT-003", retail: 10, name: "LED Bulbs — A19, 9W, 4-pack" },
    "Passage Lever": { sku: "MF-HDW-001", retail: 22, name: "Interior Door Lever — Passage" },
    "Privacy Lever": { sku: "MF-HDW-002", retail: 25, name: "Interior Door Lever — Privacy" },
    "Door Hinges": { sku: "MF-HDW-003", retail: 12, name: "Door Hinges — 3.5\" (3-pack)" },
    "Door Stop": { sku: "MF-HDW-004", retail: 8, name: "Door Stop — Wall Mount (5-pack)" },
    "Deep Clean": { sku: "MF-CLN-001", retail: 65, name: "Deep Clean Kit — Full Unit" },
    "Caulk": { sku: "MF-CLN-002", retail: 8, name: "Caulk — Kitchen & Bath Silicone" },
    "Painters Tape": { sku: "MF-CLN-003", retail: 9, name: "Painters Tape — Blue (1.41\" x 60yd)" },
    "Drywall Patch": { sku: "MF-CLN-004", retail: 15, name: "Drywall Patch Kit (6\" x 6\", 3-pack)" },
  };

  const generateShopifyOrder = () => {
    if (!result) return;
    const orderLines = [];
    result.materials.forEach(m => {
      // Try exact match first, then partial match
      let match = MATERIAL_TO_SHOPIFY[m.item];
      if (!match) {
        const key = Object.keys(MATERIAL_TO_SHOPIFY).find(k => m.item.toLowerCase().includes(k.toLowerCase()) || k.toLowerCase().includes(m.item.toLowerCase().split(" ")[0]));
        if (key) match = MATERIAL_TO_SHOPIFY[key];
      }
      if (match) {
        const qty = typeof m.qty === "string" ? parseFloat(m.qty) || 1 : m.qty;
        orderLines.push({ ...match, qty, unit: m.unit, wholesaleCost: m.cost, retailTotal: (match.retail * qty) });
      } else {
        // No match — include at wholesale + 50% markup
        const qty = typeof m.qty === "string" ? parseFloat(m.qty) || 1 : m.qty;
        const markup = m.cost * 1.5;
        orderLines.push({ sku: "CUSTOM", name: m.item, retail: +(markup / qty).toFixed(2), qty, unit: m.unit, wholesaleCost: m.cost, retailTotal: markup });
      }
    });
    const totalWholesale = orderLines.reduce((s, l) => s + l.wholesaleCost, 0);
    const totalRetail = orderLines.reduce((s, l) => s + l.retailTotal, 0);
    const profit = totalRetail - totalWholesale;
    setShopifyOrder({ lines: orderLines, totalWholesale, totalRetail, profit, unitType: result.unit_type, sqft: result.sqft });
  };

  const copyShopifyOrder = () => {
    if (!shopifyOrder) return;
    const lines = shopifyOrder.lines.map(l => `${l.name} | Qty: ${l.qty} ${l.unit} | $${l.retail.toFixed(2)} each | Line Total: $${l.retailTotal.toFixed(2)}`).join("\n");
    const text = `CLIENT MATERIALS INVOICE — ${shopifyOrder.unitType} (${shopifyOrder.sqft} sq ft)\n${"=".repeat(50)}\n\n${lines}\n\n${"=".repeat(50)}\nCLIENT TOTAL: $${shopifyOrder.totalRetail.toFixed(2)}\nYOUR COST: $${shopifyOrder.totalWholesale.toFixed(2)}\nYOUR PROFIT: $${shopifyOrder.profit.toFixed(2)} (${Math.round((shopifyOrder.profit / shopifyOrder.totalRetail) * 100)}% margin)\n\nINSTRUCTIONS:\n1. Send this itemized list to the client via HoneyBook invoice, Stripe payment link, or direct ACH/wire — whichever fits the deal.\n2. Client pays → funds land in your Relay MATERIALS account.\n3. Swipe the unit's assigned Relay debit card at the pro accounts (Home Depot Pro, Sherwin Williams, Floor & Decor, etc.) to buy at wholesale.\n4. Per-unit materials margin stays in Relay MATERIALS. Sweep at month-end.`;
    navigator.clipboard.writeText(text).then(() => {
      setOrderCopied(true);
      setTimeout(() => setOrderCopied(false), 2000);
    });
  };

  const generateAmazonCart = () => {
    if (!result) return;
    // Multi-vendor procurement: build search URLs for 7 DFW-relevant suppliers per material
    const lines = result.materials.map(m => {
      const qty = typeof m.qty === "string" ? parseFloat(m.qty) || 1 : m.qty;
      const cleanName = (m.item || "").replace(/\([^)]*\)/g, "").trim();
      const itemLower = (m.item || "").toLowerCase();
      const q = encodeURIComponent(cleanName);

      // Smart vendor matching: paint goes to Sherwin-Williams, flooring to Floor & Decor, etc.
      const isPaint = /paint|primer|drywall|joint compound/.test(itemLower);
      const isFlooring = /lvp|flooring|laminate|vinyl plank|tile|grout|underlayment/.test(itemLower);
      const isPlumbing = /faucet|toilet|valve|pipe|fitting|p-trap|water heater/.test(itemLower);
      const isBulkBuild = /lumber|stud|drywall|insulation|sheetrock|plywood|2x4|osb/.test(itemLower);
      const isLighting = /light|bulb|fixture|led|lamp|sconce|ceiling fan|chandelier/.test(itemLower);

      const vendors = [
        { name: "Amazon Pro", url: `https://www.amazon.com/s?k=${q}&i=industrial`, hint: "Pro Business pricing — apply at sign-in", priority: 3 },
        { name: "Lowe's Pro", url: `https://www.lowes.com/search?searchTerm=${q}`, hint: "PRO discount + free delivery on $300+", priority: isBulkBuild ? 1 : 2 },
        { name: "Home Depot Pro", url: `https://www.homedepot.com/s/${q}?NCNI-5`, hint: "Pro Xtra rewards + bulk pricing tiers", priority: isBulkBuild ? 1 : 2 },
        { name: "Sherwin-Williams Pro", url: `https://www.sherwin-williams.com/painting-contractors/products/search?searchTerm=${q}`, hint: "PRO Account = 30–40% off retail", priority: isPaint ? 1 : 5 },
        { name: "Floor & Decor Pro", url: `https://www.flooranddecor.com/search?q=${q}`, hint: "Pro Premier — free design + bulk pricing", priority: isFlooring ? 1 : 5 },
        { name: "Build with Ferguson", url: `https://www.build.com/search?term=${q}`, hint: "Plumbing + lighting wholesale", priority: isPlumbing ? 1 : 4 },
        { name: "Builders FirstSource", url: `https://www.bldr.com/search?q=${q}`, hint: "DFW lumber yards + drywall", priority: isBulkBuild ? 2 : 5 }
      ].sort((a, b) => a.priority - b.priority);

      // NSPIRE compliance flagging — categories that fail HUD NSPIRE inspection most often
      const isNspireCritical = isPlumbing || isLighting || /faucet|toilet|smoke|carbon|gfci|outlet|cover|grab|handrail/.test(itemLower);
      const nspireNote = isNspireCritical
        ? "Specify NSPIRE-rated equivalent — these categories are top HUD inspection failures"
        : null;

      return { name: m.item, qty, unit: m.unit, vendors, wholesaleCost: m.cost, recommended: vendors[0], nspireCritical: isNspireCritical, nspireNote };
    });
    const totalWholesale = lines.reduce((s, l) => s + (l.wholesaleCost || 0), 0);
    setAmazonCart({ lines, totalWholesale, unitType: result.unit_type, sqft: result.sqft });
  };

  const copyAmazonCart = () => {
    if (!amazonCart) return;
    const lineBlocks = amazonCart.lines.map((l, i) => {
      const vendorList = l.vendors.map(v => `   • ${v.name}: ${v.url}`).join("\n");
      return `${i + 1}. ${l.name}\n   Qty: ${l.qty} ${l.unit} | Est. wholesale: $${(l.wholesaleCost || 0).toFixed(2)}\n   ⭐ RECOMMENDED FIRST: ${l.recommended.name}\n${vendorList}`;
    }).join("\n\n");
    const text = `MULTI-VENDOR PROCUREMENT LIST — ${amazonCart.unitType} (${amazonCart.sqft} sq ft)\n${"=".repeat(70)}\n\n${lineBlocks}\n\n${"=".repeat(70)}\nEST. TOTAL WHOLESALE: $${amazonCart.totalWholesale.toFixed(2)}\n\nINSTRUCTIONS:\n1. For each item, check the RECOMMENDED vendor FIRST — they typically have the best price for that category\n2. Click the search URLs to compare live pricing across vendors before buying\n3. ALWAYS sign in with your Pro account for wholesale pricing\n4. Buy tax-free under your Texas Resale Certificate (Form 01-339)\n5. Track which vendor you actually bought from in your project notes for next time`;
    navigator.clipboard.writeText(text).then(() => {
      setAmazonCopied(true);
      setTimeout(() => setAmazonCopied(false), 2000);
    });
  };

  return (
    <div className="calc-section" data-testid="walkthrough-calculator">
      <h2>Walk-Through Material Calculator</h2>
      <p className="ops-lead">Punch in the unit details during or after your walk. Get exact material quantities, costs, and a downloadable estimate.</p>
      <div className="calc-form">
        <div className="calc-row">
          <div className="calc-field">
            <label>Unit Type</label>
            <select value={form.unit_type} onChange={e => setForm(f => ({ ...f, unit_type: e.target.value }))} data-testid="calc-unit-type">
              <option value="1br_1ba">1 BR / 1 BA (~650 sq ft)</option>
              <option value="2br_1ba">2 BR / 1 BA (~850 sq ft)</option>
              <option value="2br_2ba">2 BR / 2 BA (~1,000 sq ft)</option>
              <option value="3br_2ba">3 BR / 2 BA (~1,250 sq ft)</option>
            </select>
          </div>
          <div className="calc-field">
            <label>Actual Sq Ft</label>
            <input type="number" value={form.sqft} onChange={e => setForm(f => ({ ...f, sqft: parseInt(e.target.value) || 0 }))} data-testid="calc-sqft" />
          </div>
          <div className="calc-field">
            <label>Design Palette</label>
            <select value={form.palette} onChange={e => setForm(f => ({ ...f, palette: e.target.value }))} data-testid="calc-palette">
              {PALETTE_OPTIONS.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
            </select>
          </div>
          <div className="calc-field">
            <label>Monthly Rent ($)</label>
            <input type="number" value={form.monthly_rent} onChange={e => setForm(f => ({ ...f, monthly_rent: parseInt(e.target.value) || 0 }))} data-testid="calc-rent" />
          </div>
        </div>
        <div className="calc-scope">
          <label>Scope of Work</label>
          {["Make-Ready", "Cleaning", "Trash-Out", "Feature Walls", "Add-Ons"].map(cat => (
            <div key={cat} className="calc-scope-cat">
              <span className="calc-scope-cat-label">{cat}</span>
              <div className="calc-scope-grid">
                {SCOPE_OPTIONS.filter(s => s.cat === cat).map(s => (
                  <label key={s.key} className={`calc-scope-item ${form.scope.includes(s.key) ? "calc-scope-active" : ""}`}>
                    <input type="checkbox" checked={form.scope.includes(s.key)} onChange={() => toggleScope(s.key)} />
                    <span>{s.label}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="calc-field">
          <label>Notes</label>
          <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder="Property condition notes, special considerations..." rows={2} data-testid="calc-notes" />
        </div>
        <button onClick={calculate} disabled={loading || form.scope.length === 0} className="calc-btn" data-testid="calc-calculate-btn">{loading ? "Calculating..." : "Calculate Materials"}</button>
      </div>

      {result && (
        <div className="calc-result" data-testid="calc-result">
          <div className="calc-result-header">
            <div>
              <h3>Material Estimate — {result.unit_type}</h3>
              <span className="calc-result-meta">{result.sqft} sq ft | Palette: {result.palette?.name}</span>
            </div>
            <button onClick={downloadMaterialsPDF} className="calc-pdf-btn" data-testid="calc-download-pdf">Download PDF</button>
          </div>
          <div className="calc-palette-preview">
            <span>Wall: <strong>{result.palette?.wall_color}</strong></span>
            <span>Trim: <strong>{result.palette?.trim_color}</strong></span>
            <span>Accent: <strong>{result.palette?.accent}</strong></span>
            <span>Floor: <strong>{result.palette?.flooring}</strong></span>
            <span>Hardware: <strong>{result.palette?.hardware}</strong></span>
          </div>
          <table className="calc-table">
            <thead><tr><th>Material</th><th>Qty</th><th>Detail</th><th>Cost</th></tr></thead>
            <tbody>
              {result.materials.map((m, i) => (
                <tr key={i}><td>{m.item}</td><td>{m.qty} {m.unit}</td><td>{m.color || m.finish || "—"}</td><td>${m.cost.toFixed(2)}</td></tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="calc-total"><td colSpan={3}>Subtotal</td><td>${result.subtotal.toFixed(2)}</td></tr>
              <tr className={`calc-cap ${result.over_cap ? "calc-over-cap" : ""}`}>
                <td colSpan={3}>Materials Cap ({result.unit_type})</td>
                <td>${result.materials_cap}</td>
              </tr>
            </tfoot>
          </table>
          {result.over_cap && <div className="calc-warning" data-testid="calc-over-cap-warning">Over materials cap — review scope or adjust quantities before ordering.</div>}

          {/* Generate Client Materials Invoice Button */}
          <div className="calc-shopify-section">
            <button onClick={generateShopifyOrder} className="calc-shopify-btn" data-testid="calc-generate-order">
              Generate Client Materials Invoice
            </button>
            <button onClick={generateAmazonCart} className="calc-amazon-btn" data-testid="calc-generate-amazon-cart">
              Compare 7 Vendors (Multi-Source)
            </button>
          </div>

          {/* Client Materials Invoice Result */}
          {shopifyOrder && (
            <div className="calc-shopify-order" data-testid="shopify-order">
              <div className="calc-shopify-header">
                <h4>Client Materials Invoice</h4>
                <button onClick={copyShopifyOrder} className="product-copy-btn" data-testid="copy-shopify-order">
                  {orderCopied ? "Copied!" : "Copy Invoice Details"}
                </button>
              </div>
              <p className="calc-shopify-sub">Itemized per-unit materials, priced at the client's retail line items. Send via HoneyBook invoice, Stripe payment link, or direct ACH/wire. Funds land in Relay MATERIALS.</p>
              <div className="calc-shopify-lines">
                {shopifyOrder.lines.map((l, i) => (
                  <div key={i} className="calc-shopify-line">
                    <div className="calc-shopify-line-info">
                      <strong>{l.name}</strong>
                      <span className="calc-shopify-sku">{l.sku}</span>
                    </div>
                    <div className="calc-shopify-line-nums">
                      <span>Qty: {l.qty} {l.unit}</span>
                      <span className="calc-shopify-line-price">${l.retail.toFixed(2)} ea</span>
                      <span className="calc-shopify-line-total">${l.retailTotal.toFixed(2)}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="calc-shopify-totals">
                <div className="calc-shopify-total-row">
                  <span>Client Pays:</span>
                  <strong className="calc-shopify-client-total">${shopifyOrder.totalRetail.toFixed(2)}</strong>
                </div>
                <div className="calc-shopify-total-row">
                  <span>Your Cost (Wholesale):</span>
                  <span>${shopifyOrder.totalWholesale.toFixed(2)}</span>
                </div>
                <div className="calc-shopify-total-row calc-shopify-profit-row">
                  <span>Your Profit:</span>
                  <strong className="calc-shopify-profit">${shopifyOrder.profit.toFixed(2)} ({Math.round((shopifyOrder.profit / shopifyOrder.totalRetail) * 100)}% margin)</strong>
                </div>
              </div>
              <div className="calc-shopify-steps">
                <p><strong>Next Steps:</strong></p>
                <p>1. Send these line items to the client via HoneyBook invoice, Stripe payment link, or direct ACH/wire — pick the rail that fits the deal.</p>
                <p>2. Client pays → funds land in your Relay MATERIALS account.</p>
                <p>3. Swipe the unit's assigned Relay debit card at Home Depot Pro, Sherwin Williams, Floor &amp; Decor, etc.</p>
                <p>4. Per-unit materials margin stays in Relay MATERIALS. Sweep month-end.</p>
              </div>
            </div>
          )}

          {/* Multi-Vendor Procurement Cart */}
          {amazonCart && (
            <div className="calc-amazon-cart" data-testid="amazon-cart-result">
              <div className="calc-amazon-header">
                <h4>Multi-Vendor Procurement List</h4>
                <button onClick={copyAmazonCart} className="product-copy-btn" data-testid="copy-amazon-cart">
                  {amazonCopied ? "Copied!" : "Copy Full List"}
                </button>
              </div>
              <p className="calc-amazon-sub">Side-by-side search across <strong>7 DFW-relevant vendors</strong>. The ⭐ marks the recommended vendor for each category (paint &rarr; Sherwin-Williams, lumber &rarr; Lowe&rsquo;s/Home Depot Pro, plumbing &rarr; Ferguson, etc.). Always sign in with your Pro account for wholesale pricing. Buy tax-free with your Texas Resale Certificate (Form 01-339).</p>
              <div className="calc-amazon-lines">
                {amazonCart.lines.map((l, i) => (
                  <div key={i} className="calc-mv-item" data-testid={`mv-item-${i}`}>
                    <div className="calc-mv-item-head">
                      <div className="calc-mv-item-info">
                        <strong>{i + 1}. {l.name}</strong>
                        <span className="calc-amazon-line-qty">Qty: {l.qty} {l.unit} &middot; Est. wholesale: ${(l.wholesaleCost || 0).toFixed(2)}</span>
                        {l.nspireCritical && (
                          <span className="calc-mv-nspire" data-testid={`mv-nspire-${i}`} title={l.nspireNote}>
                            ⚠ NSPIRE-Critical &mdash; specify HUD-rated equivalent
                          </span>
                        )}
                      </div>
                      <span className="calc-mv-recommended" title="Best vendor match for this category">
                        ⭐ {l.recommended.name}
                      </span>
                    </div>
                    <div className="calc-mv-vendors">
                      {l.vendors.map((v, vi) => (
                        <a
                          key={vi}
                          href={v.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`calc-mv-vendor ${vi === 0 ? "is-recommended" : ""}`}
                          title={v.hint}
                          data-testid={`mv-vendor-${i}-${v.name.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "")}`}
                        >
                          {vi === 0 && <span className="calc-mv-star">⭐</span>}
                          <span className="calc-mv-vendor-name">{v.name}</span>
                          <span className="calc-mv-vendor-arrow">↗</span>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="calc-amazon-totals">
                <span>Estimated Total Wholesale:</span>
                <strong>${amazonCart.totalWholesale.toFixed(2)}</strong>
              </div>

              <div className="dfw-hubs-card" data-testid="dfw-hubs-card">
                <div className="dfw-hubs-header">
                  <h4>🏗 DFW Wholesale Hubs — Cash & Carry</h4>
                  <p>Beat Amazon by 20–30% in person</p>
                </div>
                <div className="dfw-hubs-grid">
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Lumber & Drywall</span>
                    <span className="dfw-hub-name">McCoy&rsquo;s Building Supply — Fort Worth</span>
                    <span className="dfw-hub-meta">3801 N. Sylvania Ave, Fort Worth &middot; <strong>Pro account: yes</strong> &middot; Cash &amp; carry</span>
                    <a className="dfw-hub-link" href="https://www.mccoys.com/store/Fort-Worth-North-001" target="_blank" rel="noopener noreferrer">Open hours &amp; phone ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Lumber Yard</span>
                    <span className="dfw-hub-name">Builders FirstSource — Dallas Yards</span>
                    <span className="dfw-hub-meta">Multiple DFW locations &middot; <strong>BLDR account = jobsite delivery + bulk pricing</strong></span>
                    <a className="dfw-hub-link" href="https://www.bldr.com/locations/" target="_blank" rel="noopener noreferrer">Find a yard ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Plumbing Wholesale</span>
                    <span className="dfw-hub-name">Ferguson — Fort Worth</span>
                    <span className="dfw-hub-meta">5121 Sandshell Dr, Fort Worth &middot; <strong>Pro PRICE = 25–40% off</strong> &middot; Will-call counter</span>
                    <a className="dfw-hub-link" href="https://www.ferguson.com/branch/fort-worth-tx-fort-worth/" target="_blank" rel="noopener noreferrer">Branch info ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Electrical Wholesale</span>
                    <span className="dfw-hub-name">Rexel / Platt — DFW</span>
                    <span className="dfw-hub-meta">Multiple DFW counters &middot; <strong>Trade pricing on lighting + breakers + wire</strong></span>
                    <a className="dfw-hub-link" href="https://www.rexelusa.com/find-a-branch" target="_blank" rel="noopener noreferrer">Find a branch ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Paint &amp; Coatings</span>
                    <span className="dfw-hub-name">Sherwin-Williams — Multiple DFW</span>
                    <span className="dfw-hub-meta">Industrial &amp; Commercial division &middot; <strong>PRO account = 30–40% off</strong> &middot; Free color matching</span>
                    <a className="dfw-hub-link" href="https://www.sherwin-williams.com/store-locator" target="_blank" rel="noopener noreferrer">Store locator ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Flooring Wholesale</span>
                    <span className="dfw-hub-name">Floor &amp; Decor Pro — Plano / Arlington</span>
                    <span className="dfw-hub-meta">Pro Premier program &middot; <strong>Bulk LVP / tile / hardwood</strong> &middot; Same-day pickup</span>
                    <a className="dfw-hub-link" href="https://www.flooranddecor.com/store-locator" target="_blank" rel="noopener noreferrer">Store locator ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Cabinets &amp; Vanities</span>
                    <span className="dfw-hub-name">Cabinets To Go — Dallas</span>
                    <span className="dfw-hub-meta">Direct-import wholesale &middot; <strong>40–50% off retail</strong> &middot; Multiple finishes for MFC palettes</span>
                    <a className="dfw-hub-link" href="https://www.cabinetstogo.com/find-a-store" target="_blank" rel="noopener noreferrer">Find a store ↗</a>
                  </div>
                  <div className="dfw-hub">
                    <span className="dfw-hub-cat">Surplus &amp; Salvage</span>
                    <span className="dfw-hub-name">Habitat for Humanity ReStore — DFW</span>
                    <span className="dfw-hub-meta">Multiple DFW locations &middot; <strong>Cabinets, doors, fixtures at 50–80% off</strong> &middot; Tax-deductible</span>
                    <a className="dfw-hub-link" href="https://www.dallasareahabitat.org/restore" target="_blank" rel="noopener noreferrer">DFW ReStores ↗</a>
                  </div>
                </div>
              </div>
            </div>
          )}

          {form.monthly_rent > 0 && (
            <div className="calc-revenue" data-testid="calc-revenue">
              <h4>Project Revenue Summary</h4>
              <div className="calc-revenue-grid">
                <div className="calc-revenue-item">
                  <span className="calc-revenue-label">Activation Capital (Materials)</span>
                  <span className="calc-revenue-val">${result.subtotal.toFixed(2)}</span>
                </div>
                <div className="calc-revenue-item calc-revenue-fee">
                  <span className="calc-revenue-label">Stabilization Fee (Rent ${form.monthly_rent.toLocaleString()} + 15%)</span>
                  <span className="calc-revenue-val">${(form.monthly_rent * 1.15).toFixed(2)}</span>
                </div>
                <div className="calc-revenue-item calc-revenue-total">
                  <span className="calc-revenue-label">Total Project Value</span>
                  <span className="calc-revenue-val">${(result.subtotal + form.monthly_rent * 1.15).toFixed(2)}</span>
                </div>
                <div className="calc-revenue-item calc-revenue-profit">
                  <span className="calc-revenue-label">Your Earned Fee</span>
                  <span className="calc-revenue-val">${(form.monthly_rent * 1.15).toFixed(2)}</span>
                </div>
              </div>
              <p className="calc-revenue-note">Activation Capital goes into the property (materials + labor). Stabilization Fee is your revenue, due within 72 hours of client sign-off. For DHA/government contracts, use fixed per-unit pricing instead.</p>
            </div>
          )}

          <div className="calc-compliance" data-testid="calc-compliance-services">
            <h4>Add-On Compliance Services</h4>
            {result.compliance_services?.filter(s => s.price > 0).map(s => (
              <div key={s.service_id} className="calc-compliance-item">
                <strong>{s.name} — ${s.price}</strong>
                <span>{s.description}</span>
              </div>
            ))}
            <div className="calc-compliance-item calc-compliance-bundle">
              <strong>Compliance Ready Package — 15% Bundle Discount</strong>
              <span>Add the NSPIRE/HQS Pre-Inspection Audit to any stabilization. Save on compliance costs.</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const COMPLIANCE_CHECKLISTS = {
  nspire: {
    title: "NSPIRE Inspection Checklist (HUD — All Assisted Housing)",
    subtitle: "National Standards for Physical Inspection of Real Estate — replaced REAC in 2023. Applies to ALL HUD-assisted properties: public housing, project-based Section 8, and transitioning to Housing Choice Voucher (HCV) properties. Life-Threatening items require 24-hour fix.",
    sections: [
      { name: "Kitchen", items: [
        { item: "Sink — drains properly, hot/cold water", severity: "S" },
        { item: "Stove/Oven — all burners/oven functional, no gas smell", severity: "S" },
        { item: "Refrigerator — cooling, clean, door seals intact", severity: "M" },
        { item: "Cabinets — doors open/close/latch, no damage", severity: "L" },
        { item: "Countertops — intact, no damage, cleanable surface", severity: "L" },
        { item: "GFCI outlets — present and functional near water", severity: "M" },
        { item: "Ventilation — range hood/exhaust fan working", severity: "M" },
        { item: "No pest evidence (roaches, rodents, droppings)", severity: "S" },
        { item: "Floor — no tripping hazards, intact covering", severity: "M" },
        { name: "Walls/ceiling — no holes, no peeling paint, no water damage", severity: "M" },
        { item: "Backsplash behind stove — heat-safe material only (metal/ceramic). NO vinyl peel-and-stick within 12\" of burners", severity: "M" },
        { item: "Backsplash edges — no lifting, peeling, or gaps", severity: "L" },
      ]},
      { name: "Bathroom(s)", items: [
        { item: "Toilet — flushes, no leaks, securely mounted", severity: "S" },
        { item: "Sink — drains, hot/cold water, no leaks", severity: "S" },
        { item: "Tub/Shower — drains, hot/cold water, caulk intact", severity: "S" },
        { item: "GFCI outlet — present and functional", severity: "M" },
        { item: "Ventilation — exhaust fan or operable window", severity: "M" },
        { item: "Privacy lock on door", severity: "L" },
        { item: "No mold or mold-like substance", severity: "S" },
        { item: "Floor — no water damage, intact covering", severity: "M" },
        { item: "Walls/ceiling — no peeling paint, no holes", severity: "M" },
      ]},
      { name: "Bedrooms", items: [
        { item: "Operable window for egress/ventilation", severity: "S" },
        { item: "Min 80 sq ft (8x10), 7'1\" ceiling height", severity: "S" },
        { item: "Working light fixture or 2 outlets", severity: "M" },
        { item: "Closet door opens/closes properly", severity: "L" },
        { item: "Smoke detector — installed, functional", severity: "LT" },
        { item: "Walls/ceiling/floor — intact, no damage", severity: "M" },
        { item: "Window locks functional", severity: "M" },
      ]},
      { name: "Living Areas", items: [
        { item: "Min 2 working outlets OR 1 outlet + 1 light fixture per room", severity: "M" },
        { item: "Windows — operable, no broken glass, locks work", severity: "M" },
        { item: "Floor — no tripping hazards (loose carpet, torn edges)", severity: "M" },
        { item: "Walls — no holes, no peeling/chipping paint", severity: "M" },
        { item: "Ceiling — no loose/detached covering, no water stains", severity: "M" },
        { item: "All doors open/close/latch properly", severity: "L" },
      ]},
      { name: "Safety (CRITICAL)", items: [
        { item: "Smoke detector — every bedroom + hallway (LIFE-THREATENING if missing)", severity: "LT" },
        { item: "CO detector — each level if gas/fuel appliances or attached garage", severity: "LT" },
        { item: "No unvented gas/oil/kerosene heaters (LIFE-THREATENING)", severity: "LT" },
        { item: "Water heater — no leaks, relief valve/pipe intact", severity: "LT" },
        { item: "No exposed/frayed electrical wiring", severity: "LT" },
        { item: "All outlet/switch covers in place", severity: "M" },
        { item: "Entry door — deadbolt + peephole, secure frame", severity: "M" },
        { item: "HVAC — heating AND cooling functional", severity: "S" },
        { item: "No lead paint hazards (pre-1978 properties)", severity: "LT" },
        { item: "No pest infestation (bed bugs, roaches, rodents)", severity: "S" },
      ]},
      { name: "Plumbing/Systems", items: [
        { item: "Hot water — min 110°F at fixtures", severity: "S" },
        { item: "Water pressure adequate at all fixtures", severity: "M" },
        { item: "No visible leaks under sinks, behind toilet", severity: "M" },
        { item: "P-traps intact under all sinks", severity: "M" },
        { item: "Dryer vent — routed to exterior (not attic/crawl)", severity: "M" },
        { item: "Drainage — no slow drains or backups", severity: "M" },
      ]},
    ]
  },
  hqs: {
    title: "HQS / Section 8 Inspection Checklist",
    subtitle: "Housing Quality Standards — the current inspection standard for Section 8 Housing Choice Voucher (HCV) properties. Must pass BEFORE HAP payments begin. Also used for HUD-VASH (veteran vouchers). Being phased into NSPIRE, but many DFW housing authorities still use HQS for voucher inspections.",
    sections: [
      { name: "Kitchen", items: [
        { item: "Sink with hot/cold running water, drains properly", severity: "FAIL" },
        { item: "Stove/range — all burners and oven functional", severity: "FAIL" },
        { item: "Refrigerator — cooling properly, clean", severity: "FAIL" },
        { item: "Adequate cabinet/storage space", severity: "FAIL" },
        { item: "No leaks at fixtures or under sink", severity: "FAIL" },
        { item: "GFCI outlets near water sources", severity: "FAIL" },
        { item: "Vent hood/exhaust filter in place", severity: "FAIL" },
      ]},
      { name: "Bathroom", items: [
        { item: "Flush toilet — no leaks, securely mounted", severity: "FAIL" },
        { item: "Fixed wash basin with hot/cold water", severity: "FAIL" },
        { item: "Tub or shower with hot/cold water", severity: "FAIL" },
        { item: "Window or working exhaust fan for ventilation", severity: "FAIL" },
        { item: "GFCI outlet present", severity: "FAIL" },
        { item: "Tub/shower caulking intact (no missing tile)", severity: "FAIL" },
        { item: "Privacy lock on bathroom door", severity: "FAIL" },
      ]},
      { name: "Rooms & Structure", items: [
        { item: "Living room present with natural light", severity: "FAIL" },
        { item: "Bedrooms — operable window, min 80 sq ft", severity: "FAIL" },
        { item: "Handrails on stairs with 4+ steps", severity: "FAIL" },
        { item: "No tripping hazards (loose carpet, cords)", severity: "FAIL" },
        { item: "Ceiling height minimum 7 feet", severity: "FAIL" },
        { item: "Closet/storage in bedroom", severity: "FAIL" },
      ]},
      { name: "Electrical & Safety", items: [
        { item: "Working smoke detector on every level", severity: "FAIL" },
        { item: "CO detector where required", severity: "FAIL" },
        { item: "Grounded 3-prong outlets throughout", severity: "FAIL" },
        { item: "All outlet/switch covers secure, no cracks", severity: "FAIL" },
        { item: "No exposed or frayed wiring", severity: "FAIL" },
        { item: "Light globes/covers on all fixtures", severity: "FAIL" },
        { item: "GFCI in all wet areas", severity: "FAIL" },
      ]},
      { name: "Doors, Windows & Security", items: [
        { item: "Entry door — lockable deadbolt + peephole/viewer", severity: "FAIL" },
        { item: "All windows operable, no broken panes", severity: "FAIL" },
        { item: "Window locks functional", severity: "FAIL" },
        { item: "Weather stripping on exterior doors", severity: "FAIL" },
        { item: "Screens intact and removable", severity: "FAIL" },
        { item: "No window bars OR quick-release bars", severity: "FAIL" },
      ]},
      { name: "Systems", items: [
        { item: "Heating system operational", severity: "FAIL" },
        { item: "Cooling system operational (if provided)", severity: "FAIL" },
        { item: "Hot water heater — relief valve, no leaks", severity: "FAIL" },
        { item: "Hot water at min 110°F", severity: "FAIL" },
        { item: "No sewer/septic backups or odors", severity: "FAIL" },
        { item: "Adequate water pressure", severity: "FAIL" },
      ]},
    ]
  },
  code311: {
    title: "311 Code Enforcement Checklist (DFW)",
    subtitle: "Fort Worth (817-392-6574) and Dallas (214-670-3111) code compliance standards for multi-tenant/rental properties.",
    sections: [
      { name: "Interior — Walls/Ceilings/Floors", items: [
        { item: "No holes in walls or ceilings", severity: "VIOL" },
        { item: "No peeling/chipping paint (lead-safe if pre-1978)", severity: "VIOL" },
        { item: "Floors — no damaged/missing covering, no tripping hazards", severity: "VIOL" },
        { item: "Carpets secured, no excessive wear", severity: "VIOL" },
        { item: "No insect/rodent infestation (including bed bugs)", severity: "VIOL" },
        { item: "Dirty walls cleaned or painted", severity: "VIOL" },
      ]},
      { name: "Weather & Water Tightness", items: [
        { item: "Weather stripping on exterior doors/windows", severity: "VIOL" },
        { item: "Sink/tub/shower water-tight (no missing tile/caulk)", severity: "VIOL" },
        { item: "No plumbing leaks anywhere", severity: "VIOL" },
        { item: "Hot water at min 110°F", severity: "VIOL" },
      ]},
      { name: "Security & Doors", items: [
        { item: "Peephole/door viewer on entry door", severity: "VIOL" },
        { item: "Keyless deadbolt lock on entry door", severity: "VIOL" },
        { item: "All doors open/close/latch properly", severity: "VIOL" },
        { item: "Privacy locks on bathroom doors", severity: "VIOL" },
        { item: "Cabinet doors open/close/latch", severity: "VIOL" },
      ]},
      { name: "Electrical & HVAC", items: [
        { item: "No missing switch/outlet cover plates", severity: "VIOL" },
        { item: "No exposed wiring", severity: "VIOL" },
        { item: "A/C operational (if provided)", severity: "VIOL" },
        { item: "Heating system operational", severity: "VIOL" },
      ]},
      { name: "Safety", items: [
        { item: "Smoke alarms on every level + bedrooms", severity: "VIOL" },
        { item: "CO detectors where required", severity: "VIOL" },
        { item: "No improper sewage discharge", severity: "VIOL" },
        { item: "Unit completely cleaned from previous tenant", severity: "VIOL" },
        { item: "All construction completed, tools removed", severity: "VIOL" },
      ]},
    ]
  },
};

const SEVERITY_COLORS = { LT: "#FF1744", S: "#FF6B35", M: "#FFC107", L: "#8BC34A", FAIL: "#FF6B35", VIOL: "#FF6B35" };
const SEVERITY_LABELS = { LT: "Life-Threatening", S: "Severe", M: "Moderate", L: "Low", FAIL: "Fail", VIOL: "Violation" };

const ComplianceChecklist = ({ type }) => {
  const [checks, setChecks] = useState({});
  const [notes, setNotes] = useState({});
  const checklist = COMPLIANCE_CHECKLISTS[type];
  if (!checklist) return null;
  const toggle = (key) => setChecks(p => ({ ...p, [key]: !p[key] }));
  const updateNote = (key, val) => setNotes(p => ({ ...p, [key]: val }));
  const totalItems = checklist.sections.reduce((s, sec) => s + sec.items.length, 0);
  const checked = Object.values(checks).filter(Boolean).length;

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14); doc.setFont("helvetica", "bold");
    doc.text(`MOOVIN FORWARD — ${checklist.title}`, 12, 18);
    doc.setFontSize(7); doc.setFont("helvetica", "normal"); doc.setTextColor(100);
    doc.text(`${checked}/${totalItems} items checked | Generated: ${new Date().toLocaleDateString()}`, 12, 24);
    doc.text("EMERGENCY: Shannon (CEO) (817) 381-8831 | Shanek (COO) — Contact via Shared Board", 12, 29);
    doc.setTextColor(0); let y = 36;
    checklist.sections.forEach(sec => {
      if (y > 265) { doc.addPage(); y = 15; }
      doc.setFontSize(9); doc.setFont("helvetica", "bold");
      doc.text(sec.name, 12, y); y += 5;
      doc.setFontSize(7.5); doc.setFont("helvetica", "normal");
      sec.items.forEach(it => {
        if (y > 270) { doc.addPage(); y = 15; }
        const key = `${type}-${sec.name}-${it.item}`;
        doc.text(`[${checks[key] ? "X" : " "}] [${it.severity}] ${it.item}`, 14, y); y += 4.5;
        const note = notes[key];
        if (note) { doc.setTextColor(120); doc.text(`   Note: ${note}`, 18, y); doc.setTextColor(0); y += 4; }
      });
      y += 3;
    });
    doc.setFontSize(6); doc.setTextColor(140);
    doc.text("Moovin Forward | moovinforward.org | (817) 381-8831 | CONFIDENTIAL", 12, 288);
    doc.save(`MF-${type.toUpperCase()}-Checklist-${new Date().toISOString().slice(0,10)}.pdf`);
  };

  return (
    <div className="compliance-checklist" data-testid={`checklist-${type}`}>
      <div className="compliance-cl-header">
        <div>
          <h3>{checklist.title}</h3>
          <p className="compliance-cl-sub">{checklist.subtitle}</p>
        </div>
        <div className="compliance-cl-actions">
          <span className="compliance-cl-progress" data-testid={`progress-${type}`}>{checked}/{totalItems}</span>
          <button onClick={downloadPDF} className="compliance-cl-pdf" data-testid={`pdf-${type}`}>PDF</button>
        </div>
      </div>
      {checklist.sections.map(sec => (
        <div key={sec.name} className="compliance-cl-section">
          <h4>{sec.name}</h4>
          {sec.items.map(it => {
            const key = `${type}-${sec.name}-${it.item}`;
            return (
              <div key={key} className={`compliance-cl-item-wrap ${checks[key] ? "compliance-cl-done" : ""}`}>
                <label className="compliance-cl-item">
                  <input type="checkbox" checked={!!checks[key]} onChange={() => toggle(key)} />
                  <span className="compliance-cl-severity" style={{ background: SEVERITY_COLORS[it.severity] || "#888" }}>{it.severity}</span>
                  <span className="compliance-cl-text">{it.item}</span>
                </label>
                <input
                  type="text"
                  placeholder="Notes / violation details..."
                  value={notes[key] || ""}
                  onChange={e => updateNote(key, e.target.value)}
                  className="compliance-cl-note"
                />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

const FieldToolsTab = () => {
  const [activeChecklist, setActiveChecklist] = useState("nspire");
  const [checks, setChecks] = useState({});
  const toggle = (key) => setChecks(p => ({ ...p, [key]: !p[key] }));

  const phases = [
    { title: "Phase 1 — Online & Digital Presence", items: [
      "Property website — address, hours, phone, email correct, all links work",
      "Google Business Profile — correct info, floorplans uploaded, high quality images",
      "Facebook — correct info, community logo, high quality header image",
      "Instagram — correct info, community logo, high quality feed images",
    ]},
    { title: "Phase 2 — Curb Appeal & Exterior", items: [
      "Parking lot condition — no potholes, properly striped",
      "Exterior lighting — all functioning",
      "Building entrance — clean, presentable",
      "Landscaping — maintained, trimmed, no dead plants",
      "Signage/Flags/Banners — presentable, clear, properly located",
      "Mailbox area — free of debris and clutter",
      "Dumpster / trash enclosures — in good repair, areas clean",
      "Balconies/Patios — free of trash, clutter, inappropriate items",
      "Windows — no broken/tattered blinds, no foil or blankets",
      "Curbs/Lots — painted/striped, no scattered trash",
    ]},
    { title: "Phase 3 — Office & Clubhouse", items: [
      "Front door unlocked or promptly opened",
      "Office clean, free of odors, blinds open, lights operational",
      "Restrooms — functioning, clean floors/walls, paper products/soap stocked",
      "Signage framed/posted professionally (no taped paper signs)",
      "Desks clean, organized, minimal personal items",
      "Fair Housing, No Cash, Office Hours, ID signage displayed",
      "Refreshments/candy available",
      "Music on at acceptable volume, appropriate channel",
      "Entry mats clean and in good condition",
      "Furniture condition: Good/Fair/Poor",
    ]},
    { title: "Phase 4 — Amenities & Common Areas", items: [
      "Lobby / entryway — clean, presentable",
      "Hallways & corridors — clean, lit, no obstructions",
      "Stairwells — clean, well-lit, handrails secure",
      "Elevator condition — functional, clean",
      "Laundry facility — equipment working, clean",
      "Community room / fitness center — clean, dust free, fresh-smelling",
      "All equipment in working order",
      "Supplies stocked (wipes, towels, water)",
      "Furniture clean, good condition, presentable",
      "Pet waste receptacles emptied and stocked with bags",
      "Fire safety equipment — present and current",
    ]},
    { title: "Phase 5 — Breezeways, Corridors & Stairwells", items: [
      "Clean, dust free, fresh-smelling, lights functioning",
      "Paint touched-up where needed",
      "Mailbox area free of debris and clutter",
    ]},
    { title: "Phase 6 — Model / Show Unit", items: [
      "Clean, dust free, fresh-smelling, all lights/blinds on",
      "Carpet/Flooring clean and vacuumed",
      "Decor tasteful and in good condition",
      "Unit fully made ready and in good repair",
      "WOW Fridge stocked and presentable",
    ]},
    { title: "Phase 7 — Unit Interior Walkthrough", items: [
      "Front door & locks — secure, deadbolt functional",
      "Walls & paint condition — no holes, scuffs, peeling",
      "Flooring throughout — no damage, tripping hazards",
      "Kitchen cabinets & counters — doors latch, surfaces clean",
      "Appliance condition — stove, fridge, dishwasher functional",
      "Bathroom fixtures — toilet, sink, tub/shower functional",
      "Windows & blinds — operable, locks work, blinds intact",
      "Closet doors & hardware — open/close/latch properly",
      "Light fixtures & switches — all operational",
      "HVAC system — heating and cooling functional",
      "Water pressure & drainage — adequate, no leaks",
      "Smoke / CO detectors — installed and functional in every bedroom",
    ]},
    { title: "Phase 8 — Staff & Presentation", items: [
      "Staff greeted you immediately with introductions and a smile",
      "Staff knowledgeable about property, floorplans, pricing",
      "Staff professional appearance and demeanor",
      "Leasing materials current and available",
    ]},
  ];

  const downloadAuditPDF = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(16); pdf.text("Moovin Forward — Audit Checklist", 20, 20);
    let y = 35;
    phases.forEach(phase => {
      pdf.setFontSize(12); pdf.text(phase.title, 20, y); y += 8;
      pdf.setFontSize(10);
      phase.items.forEach(item => {
        const key = `${phase.title}-${item}`;
        pdf.text(`[${checks[key] ? "X" : " "}] ${item}`, 25, y); y += 6;
        if (y > 270) { pdf.addPage(); y = 20; }
      });
      y += 4;
    });
    pdf.save("moovin-forward-audit-checklist.pdf");
  };

  return (
    <div className="dash-tab-content" data-testid="field-tools-tab">
      <WalkThroughCalc />

      {/* Compliance Inspection Checklists */}
      <div className="field-compliance-section" style={{ marginTop: "2rem" }}>
        <h2>Compliance Inspection Checklists</h2>
        <p className="ops-lead">Pull these up on your phone during walk-throughs. Check off each item to verify the unit is inspection-ready.</p>
        <div className="compliance-tab-nav" data-testid="compliance-tab-nav">
          <button className={`compliance-tab-btn ${activeChecklist === "nspire" ? "active" : ""}`} onClick={() => setActiveChecklist("nspire")} data-testid="tab-nspire">NSPIRE (HUD)</button>
          <button className={`compliance-tab-btn ${activeChecklist === "hqs" ? "active" : ""}`} onClick={() => setActiveChecklist("hqs")} data-testid="tab-hqs">Section 8 (HQS)</button>
          <button className={`compliance-tab-btn ${activeChecklist === "code311" ? "active" : ""}`} onClick={() => setActiveChecklist("code311")} data-testid="tab-code311">311 Code Enforcement</button>
        </div>
        <ComplianceChecklist type={activeChecklist} />
      </div>

      {/* Field Audit */}
      <div className="tools-header" style={{ marginTop: "2rem" }}>
        <h2>Property Walk-Through Audit</h2>
        <button onClick={downloadAuditPDF} className="dash-download-btn" data-testid="download-checklist-btn">Download PDF</button>
      </div>
      {phases.map(phase => (
        <div key={phase.title} className="checklist-phase">
          <h3>{phase.title}</h3>
          {phase.items.forEach ? phase.items.map(item => {
            const key = `${phase.title}-${item}`;
            return (
              <label key={key} className="check-item">
                <input type="checkbox" checked={!!checks[key]} onChange={() => toggle(key)} />
                <span>{item}</span>
              </label>
            );
          }) : null}
        </div>
      ))}
      <div className="script-section">
        <h2>On-Site Script</h2>
        <div className="script-card">
          <p><strong>Introduction:</strong> "Hi [Manager Name], I'm with Moovin Forward. We specialize in turning vacant, underperforming units into market-ready assets — fast. I'd love to walk [Unit Number] and show you exactly what we'd do."</p>
          <p><strong>Assessment:</strong> "I'll document everything — condition, fixtures, layout. Then I'll send you a detailed scope with line items and timeline. No obligation."</p>
          <p><strong>Close:</strong> "Based on what I've seen, we can typically have a unit like this market-ready within 2-3 weeks. Want me to send over the assessment?"</p>
        </div>
      </div>
      <RoomVisualizer />
    </div>
  );
};

export default FieldToolsTab;
